const initialState = {
    logged: false,
    token: null,
    tokenId: null,
    expiresAt: null,
    userProfile: null
};

export default function reducerUser(state = initialState, action) {
    switch (action.type) {
        case "TOKEN_TOKEN":
            return {
                token: null
            };
        case "LOGGED_IN":
            return {
                ...state,
                logged: true,
                token: action.payload.token,
                tokenId: action.payload.tokenId,
                expiresAt: action.payload.expiresAt,
                userProfile: action.payload.userProfile
            };
        case "LOGGED_OUT":
            return {
                ...state,
                logged: false,
                token: null,
                tokenId: null,
                expiresAt: null,
                userProfile: null
            };
        default:
            return state;
    }
}